var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function move(arr, _a) {
    var fromIdx = _a.fromIdx, toIdx = _a.toIdx, _b = _a.length, length = _b === void 0 ? 1 : _b;
    if (fromIdx > arr.length - 1) {
        throw Error('From index out of bounds');
    }
    if (toIdx > arr.length - 1) {
        throw Error('To index out of bounds');
    }
    var arrCopy = __spreadArray([], __read(arr), false);
    var movingItems = arrCopy.splice(fromIdx, length);
    arrCopy.splice.apply(arrCopy, __spreadArray([toIdx, length - 1], __read(movingItems), false));
    return arrCopy;
}
